import { passwordValidation } from 'src/lib'
import { z } from 'zod'

export const registerZodSchema = z
  .object({
    email: z.string().email({ message: 'error.email.invalid' }),
    password: z.string().regex(passwordValidation, {
      message: 'error.password.invalid',
    }),
    confirmPassword: z.string(),
    firstName: z.string().min(3),
    lastName: z.string().min(3),
  })
  .refine((values) => values.password === values.confirmPassword, {
    message: 'error.password.mismatch',
    path: ['confirmPassword'],
  })

export type registerType = z.infer<typeof registerZodSchema>
